export default {
  props: {
    style: {
      type: String
    }
  }
};